<template>
	<div>
		<section class="heading">
			<h1 class="title">{{ title }}</h1>
			<button @click="$router.back()" class="btn btn-link btn-lg btn-cancel" :disabled="isLoading">
				Back
			</button>
		</section>
		<form @submit="e => { e.preventDefault(); onSubmit(fields); }">
			<div class="row">
				<div class="col-sm-6">
					<div class="box box-primary">
						<div class="box-header with-border">Personal Info</div>
						<div class="box-body">
							<input-wrapper id="name" label="Name" :error="errors.name">
								<input v-model="fields.name" id="name" name="name" type="text" class="form-control" :disabled="isLoading" required>
							</input-wrapper>
							<input-wrapper id="email" label="Email" :error="errors.email">
								<input v-model="fields.email" id="email" name="email" type="email" class="form-control" :disabled="isLoading">
							</input-wrapper>
							<input-wrapper id="phone" label="Phone" :error="errors.phone">
								<input v-model="fields.phone" id="phone" name="phone" type="text" class="form-control" :disabled="isLoading">
							</input-wrapper>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="box box-primary">
						<div class="box-header with-border">Company Info</div>
						<div class="box-body">
							<input-wrapper id="company_name" label="Company Name" :error="errors.company_name">
								<input v-model="fields.company_name" id="company_name" name="company_name" type="text" class="form-control" :disabled="isLoading" required>
							</input-wrapper>
							<input-wrapper id="company_description" label="Company Description" :error="errors.company_description">
								<textarea v-model="fields.company_description" id="company_description" name="company_description" class="form-control" :disabled="isLoading"></textarea>
							</input-wrapper>
							<input-wrapper id="company_address" label="Company Address" :error="errors.company_address">
								<textarea v-model="fields.company_address" id="company_address" name="company_address" class="form-control" :disabled="isLoading"></textarea>
							</input-wrapper>
						</div>
					</div>
				</div>
				
			</div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <input-wrapper id="note" label="Note" :error="errors.note">
                                <textarea v-model="fields.note" id="note" name="note" class="form-control" :disabled="isLoading"></textarea>
                            </input-wrapper>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 text-right">
					<button class="btn btn-primary btn-lg" :disabled="isLoading">
						<i class="fa fa-circle-o-notch fa-spin" v-show="isLoading"></i>
						{{ submitTxt }}
					</button>
				</div>
            </div>
		</form>
	</div>
</template>

<script>
import { defaultFields } from "./helpers";
import InputWrapper from "../InputWrapper.vue";

export default {
	components: {
		InputWrapper,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		submitTxt: {
			type: String,
			required: true,
		},
		onSubmit: {
			type: Function,
			required: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		fields: {
			type: Object,
			default: defaultFields,
		},
		errors: {
			type: Object,
			default: defaultFields,
		}
	},
}
</script>
